import { apiSlice } from '../../../app/api/apiSlice';
import Config from '../../../configs/appConfig';
import makeQueryParams from '../../../lib/makeQueryParams';



export const CategoriesApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => {
    return ({
      getCategories: builder.query({
        query: (params) => {
          const queryParams = makeQueryParams(params.queryParams);

          return ({ url: `/${Config.VITE_HC_API_VERSION}/categories${queryParams}` });
        },
        transformResponse: (response) => {
          return {
            data: response.data,
            pagination: response.meta.pagination,
          };
        },
        transformErrorResponse: (response) => response?.data?.errors,
        providesTags: [ 'Categories' ],
        keepUnusedDataFor: 1,
      }),
      getCategory: builder.query({
        query: ({ categoryId, includes }) => ({
          url: `/${Config.VITE_HC_API_VERSION}/categories/${categoryId}${includes}`,
          method: 'GET',
        }),
        transformResponse: (response) => response.data,
        providesTags: [ 'CategoryItem' ],
      }),
      createCategory: builder.mutation({
        query: ({ values }) => {
          return ({
            url: `/${Config.VITE_HC_API_VERSION}/categories`,
            method: 'POST',
            body: values,
          });
        },
        invalidatesTags: () => [ 'Categories', 'Structures', 'Dictionaries', 'Templates' ],
      }),
      updateCategory: builder.mutation({
        query: ({ categoryId, values }) => ({
          url: `/${Config.VITE_HC_API_VERSION}/categories/${categoryId}`,
          method: 'POST',
          body: values,
        }),
        invalidatesTags: () => [ 'Categories', 'CategoryItem', 'CategoriesPriority', 'Template', 'Images', 'Feeds' ],
      }),
      deleteCategory: builder.mutation({
        query: (id) => ({
          url: `/${Config.VITE_HC_API_VERSION}/categories/${id}`,
          method: 'DELETE',
        }),
        invalidatesTags: () => [ 'Categories', 'Template' ],
      }),
      unpublishCategory: builder.mutation({
        query: (id) => ({
          url: `/${Config.VITE_HC_API_VERSION}/categories/${id}/unpublish`,
          method: 'POST',
        }),
        invalidatesTags: () => [ 'Categories', 'CategoryItem', 'CategoriesPriority' ],
      }),
      getCategoriesPriorities: builder.query({
        query: () => {
          return ({ url: `/${Config.VITE_HC_API_VERSION}/categories/settings/priorities` });
        },
        transformResponse: (response) => {
          return response.data;
        },
        providesTags: [ 'CategoriesPriority' ],
        keepUnusedDataFor: 1,
      }),
      updateCategoriesPriority: builder.mutation({
        query: (payload) => ({
          url: `/${Config.VITE_HC_API_VERSION}/categories/settings/priorities`,
          method: 'POST',
          body: payload,
        }),
        invalidatesTags: () => [ 'CategoriesPriority' ],
      }),
    });
  },
});

export const {
  useGetCategoriesQuery,
  useGetCategoryQuery,
  useDeleteCategoryMutation,
  useUnpublishCategoryMutation,
  useCreateCategoryMutation,
  useUpdateCategoryMutation,
  useGetCategoriesPrioritiesQuery,
  useUpdateCategoriesPriorityMutation,
} = CategoriesApiSlice;
